import template from './grey-list.list-item.html';
import './page.grey-list.scss';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.document.page.grey-list.tcGreyListItem',
    []
  )
  .component('tcGreyListItem', {
    //tc-grey-list-item
    template,
    bindings: {
      item: '<',
      isRootItem: '<',
    },
  }).name;
